export const SHIP_TERMS_CONSTRAINTS = {
    name: { maxLength: 30, label: 'Ship terms name' },
};
//# sourceMappingURL=constraints.js.map